import React from 'react';
import { BlueprintIcon } from '../components/IndustryIcons';
import { PESeal } from '../components/PESeal';
import { FocalQuote, Panel, SectionFrame } from '../components/SectionFrame';
const credentials = [{
  title: 'Professional Engineer — State of Florida',
  detail: 'Licensed P.E., the discipline underwriting every capital and technology recommendation.'
}, {
  title: 'Deloitte US Next Generation CIO Academy',
  detail: 'Graduate of the executive program for enterprise technology leadership.'
}, {
  title: 'Executive M.B.A. — University of South Florida',
  detail: 'Executive Master of Business Administration, 2010–2012.'
}, {
  title: 'B.S. Electrical & Electronics Engineering — University of South Florida',
  detail: 'Bachelor of Science, 1987–1992.'
}];
export function Leadership() {
  return <SectionFrame index="06" eyebrow="Organizational Capacity" headline="High-Performance Culture: Rebuilding Employee Engagement" subheadline="Results of this size require an organization capable of carrying them. This is how the leadership bench was rebuilt — and the credentials behind the person who rebuilt it." data-id="element-259" data-mp="6plkp3gdiqb">
      <div className="grid gap-6 lg:grid-cols-2" data-id="element-260" data-mp="3n5i0r6ywm43k">
        <Panel className="p-7 sm:p-9" data-id="element-261" data-mp="3n8dzuymhmytl">
          <h2 className="display text-2xl font-black text-steel-dark" data-id="element-262" data-mp="3i7q9mf632m0f">Culture & Engagement</h2>
          <p className="mt-3 text-[15px] leading-relaxed text-steel-dark/85" data-id="element-263" data-mp="jpb6ts6ajl7z">
            Applied the Rocket Model operating system to rebuild the executive leadership team and operating model,
            raising organizational employee engagement from 11% to 70% within eight months and building a leadership
            bench 50+ promotions deep.
          </p>

          <div className="mt-8 flex items-end gap-6" data-id="element-264" data-mp="4ylugmh3g02j">
            <div className="flex-1" data-id="element-265" data-mp="12h42jucqvkje">
              <div className="flex items-baseline justify-between" data-id="element-266" data-mp="12i5es25hyd2p">
                <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-steel-dark/60" data-id="element-267" data-mp="xokda04p30yr">
                  Engagement, month 0
                </span>
                <span className="tabular display text-xl font-black text-steel-dark/60" data-id="element-268" data-mp="2wwspalz2e4vz">11%</span>
              </div>
              <div className="mt-2 h-3 w-full bg-panel-deep" data-id="element-269" data-mp="2i868eftsh52n">
                <div className="h-3 bg-steel-light" style={{
                width: '11%'
              }} data-id="element-270" data-mp="2n6hm51n7fzq5" />
              </div>

              <div className="mt-6 flex items-baseline justify-between" data-id="element-271" data-mp="296pz6bepn900">
                <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-copper" data-id="element-272" data-mp="295ewyg0wy9b0">
                  Engagement, month 8
                </span>
                <span className="tabular display text-2xl font-black text-steel-dark" data-id="element-273" data-mp="1z9k9n7lqvq1w">70%</span>
              </div>
              <div className="mt-2 h-3 w-full bg-panel-deep" data-id="element-274" data-mp="248eqw542d6jw">
                <div className="h-3 bg-copper" style={{
                width: '70%'
              }} data-id="element-275" data-mp="3tm1q9wc2vrxk" />
              </div>
            </div>
          </div>

          <div className="mt-8 grid gap-6 border-t border-panel-deep pt-6 sm:grid-cols-2" data-id="element-276" data-mp="2f7d5043mx04">
            <div data-id="element-277" data-mp="1mzchm84s2h6f">
              <p className="tabular display text-3xl font-black text-steel-dark" data-id="element-278" data-mp="1mysyio3e5mqt">50+</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-copper" data-id="element-279" data-mp="1i09eit8cyl13">
                Promotions built into the bench
              </p>
            </div>
            <div data-id="element-280" data-mp="1rx46sue1fp6x">
              <p className="tabular display text-3xl font-black text-steel-dark" data-id="element-281" data-mp="1rwm4ph4p2gr3">8 mo.</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-copper" data-id="element-282" data-mp="25nr8mvf3hv78">
                Time to the engagement result
              </p>
            </div>
          </div>
        </Panel>

        <Panel tone="steel" className="flex flex-col p-7 sm:p-9" data-id="element-283" data-mp="2flndx6lcpvxf">
          <div className="flex items-start gap-5" data-id="element-284" data-mp="2anc9jbdtsdml">
            <PESeal className="h-24 w-24 shrink-0" data-id="element-285" data-mp="2alsprasynkg2" />
            <div data-id="element-286" data-mp="l85r5lsrt33g">
              <h2 className="display text-2xl font-black text-panel" data-id="element-287" data-mp="l9qm3cizyo1u">Executive Credentials</h2>
              <p className="mt-2 text-[15px] leading-relaxed text-panel/75" data-id="element-288" data-mp="gb5vm4tjriql">
                Engineering license, executive business training, and formal CIO development — the combination that lets
                him sit on either side of a capital conversation.
              </p>
            </div>
          </div>

          <ul className="mt-7 divide-y divide-white/10 border-t border-white/10" data-id="element-289" data-mp="3dgzi2n42vq3q">
            {credentials.map(c => <li key={c.title} className="flex gap-4 py-4" data-id="element-290" data-mp="3hfqj35bnzrw4">
                <BlueprintIcon className="mt-0.5 h-6 w-6 shrink-0 text-hydro-light" data-id="element-291" data-mp="2kt3npp1zeaa4" />
                <div data-id="element-292" data-mp="2pryhtn5efl9j">
                  <p className="font-semibold text-panel" data-id="element-293" data-mp="2prex5yod6irt">{c.title}</p>
                  <p className="mt-1 text-sm leading-relaxed text-panel/65" data-id="element-294" data-mp="2ts8kaptzftjn">{c.detail}</p>
                </div>
              </li>)}
          </ul>
        </Panel>
      </div>

      <FocalQuote data-id="element-295" data-mp="221uezi01bpjl">
        Behind every successful enterprise transformation is a culture of empowered people aligned around a shared
        vision.
      </FocalQuote>
    </SectionFrame>;
}